const DECIMAL_QUANTITY = /^\d*\.?\d*$/;
const WHOLE_QUANTITY = /^\d*$/;

export const isValidRestoQuantityInput = (value, wholeNumbersOnly = false) => {
  if (value === "") return true;
  return (wholeNumbersOnly ? WHOLE_QUANTITY : DECIMAL_QUANTITY).test(String(value));
};

export const calculatePredictiveSmallQuantity = (quantity, smallUnitCount) => {
  if (quantity === "") return "";
  const parsedQuantity = Number(quantity);
  const parsedSmallUnitCount = Number(smallUnitCount);
  if (!Number.isFinite(parsedQuantity) || !Number.isFinite(parsedSmallUnitCount)) return "";
  return Number((parsedQuantity * parsedSmallUnitCount).toFixed(6));
};

export const calculateMainQuantityFromSmall = (
  smallQuantity, smallUnitCount, wholeMainUnitsOnly = false,
) => {
  if (smallQuantity === "") return "";
  const parsedSmallQuantity = Number(smallQuantity);
  const parsedSmallUnitCount = Number(smallUnitCount);
  if (!Number.isFinite(parsedSmallQuantity) || !Number.isFinite(parsedSmallUnitCount)
    || parsedSmallUnitCount <= 0) return "";
  const convertedQuantity = parsedSmallQuantity / parsedSmallUnitCount;
  return wholeMainUnitsOnly
    ? Math.floor(convertedQuantity)
    : Number(convertedQuantity.toFixed(6));
};
